import { useState, useEffect } from 'react';
import { Dialog, Checkbox, TextInputField } from 'evergreen-ui';

const SubsectionForm = ({ isShown, onClose, onSave, initial = {}, sectionId }) => {
    const [name, setName] = useState(initial.name || '');
    const [visible, setVisible] = useState(initial.is_visible_to_educators ?? true);

    useEffect(() => {
        setName(initial.name || '');
        setVisible(initial.is_visible_to_educators ?? true);
    }, [initial]);

    const handleSave = () => {
        const payload = {
            section_id: sectionId,
            name,
            is_visible_to_educators: visible ? 1 : 0,
        };

        onSave(payload);
    };

    return (
        <Dialog 
            isShown={isShown} 
            title={initial.id ? 'Modifica sottocartella' : 'Nuova sottocartella'}
            onCloseComplete={onClose}
            confirmLabel="Salva modifiche" 
            cancelLabel='Annulla modifiche'
            onConfirm={handleSave}
        >
            <TextInputField
                value={name} 
                onChange={e => setName(e.target.value)} 
                label="Nome sottocartella" 
                width="100%" 
            />
            <Checkbox
                marginTop={8}
                checked={visible} 
                onChange={e => setVisible(e.target.checked)} 
                label="Visibile agli educatori"
            />
        </Dialog>
    );
};

export default SubsectionForm;
